import { useDragLayer } from 'react-dnd';
import {ReactComponent as GrooveLoopIcon} from './icons/groove-loop.svg'
import {ReactComponent as GrooveOneShotIcon} from './icons/groove-one-shot.svg'
import {ReactComponent as LickLoopIcon} from './icons/lick-loop.svg'
import {ReactComponent as LickOneShotIcon} from './icons/lick-one-shot.svg'

const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%'
};
function getItemStyles(initialOffset, currentOffset) {
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        };
    }
    let { x, y } = currentOffset;
    y -= 15;
    x -= 7;
    const transform = `translate(${x}px, ${y}px)`;
    return {
        transform,
        WebkitTransform: transform,
    };
}
export const CustomDragLayer = () => {
    const { isDragging, item, initialOffset, currentOffset} = useDragLayer((monitor) => ({
        item: monitor.getItem(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        currentOffset: monitor.getClientOffset(),
        isDragging: monitor.isDragging(),
    }));
    function renderItem(item) {
        return item.type === 'groove' ? (item.beats === 0 ? <GrooveOneShotIcon /> : <GrooveLoopIcon />) : (item.beats === 0 ? <LickOneShotIcon /> : <LickLoopIcon />);
    }
    if (!isDragging) {
        return null;
    }
    return (<div style={layerStyles}>
			<div style={getItemStyles(initialOffset, currentOffset)}>
				{renderItem(item)}
			</div>
		</div>);
};
